import React from "react";
import { rangePreset } from "./networkFmt";

const PRESETS = [["month", "This month"], ["last_month", "Last month"], ["30d", "30 days"], ["year", "This year"]];
const input = "bg-[#0a0a0a] border border-white/15 rounded-md text-xs px-2 py-1.5 text-white/80";

/** Date range + client filter — applied across every server in the selection. */
export default function NetworkFilters({ sel, clients, onChange }) {
    const preset = (k) => { const r = rangePreset(k); onChange({ dateFrom: r.from, dateTo: r.to }); };
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="network-filters">
            {PRESETS.map(([k, label]) => {
                const r = rangePreset(k);
                const active = r.from === sel.dateFrom && r.to === sel.dateTo;
                return (
                    <button key={k} onClick={() => preset(k)} data-testid={`network-range-${k}`}
                        className={`px-2.5 py-1 rounded-md text-[11px] transition-colors ${active ? "bg-white/10 text-white" : "text-white/50 hover:text-white"}`}>
                        {label}
                    </button>
                );
            })}
            <input type="date" value={sel.dateFrom} max={sel.dateTo} data-testid="network-date-from" aria-label="From"
                onChange={(e) => e.target.value && onChange({ dateFrom: e.target.value })} className={input} />
            <span className="text-white/30 text-xs">→</span>
            <input type="date" value={sel.dateTo} min={sel.dateFrom} data-testid="network-date-to" aria-label="To"
                onChange={(e) => e.target.value && onChange({ dateTo: e.target.value })} className={input} />
            <select value={sel.clientId} onChange={(e) => onChange({ clientId: e.target.value })} data-testid="network-client-filter"
                aria-label="Client" className={`${input} max-w-[12rem]`}>
                <option value="">All clients</option>
                {sel.clientId && !clients.some((c) => c.client_id === sel.clientId) && <option value={sel.clientId}>{sel.clientId}</option>}
                {clients.map((c) => <option key={c.client_id} value={c.client_id}>{c.name}</option>)}
            </select>
        </div>
    );
}
